import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { AbstractSignsPortalAssociationControllerRequestService } from '../abstract-signs-portal-association-controller-request.service';

@Injectable({
  providedIn: 'root',
})
export class SignStickerPortalOverviewControllerRequestService extends AbstractSignsPortalAssociationControllerRequestService {
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    super(http, snackService, loadingService, router, '/signstickers/global');
  }
}
